import { usePersistentState } from "@/hooks/usePersistentState";

export const PeerReview = () => {
  const [clear, setClear] = usePersistentState("build.peer_clear", "");
  const [add, setAdd] = usePersistentState("build.peer_add", "");

  const field = "w-full resize-none bg-white border border-sand focus:border-orange focus:outline-none px-3 py-2";

  return (
    <div data-testid="peer-review">
      <div className="callout-guidance text-teal mb-8">
        Pair with a table from the other organization for this.
      </div>
      <label className="block mb-1 font-semibold">What is clear</label>
      <textarea
        data-testid="peer-clear"
        rows={3}
        value={clear}
        onChange={(e) => setClear(e.target.value)}
        className={`${field} mb-6`}
      />
      <label className="block mb-1 font-semibold">What would you add</label>
      <textarea
        data-testid="peer-add"
        rows={3}
        value={add}
        onChange={(e) => setAdd(e.target.value)}
        className={field}
      />
      <p className="mono-label text-ink/60 mt-6">Apply one fix, not five.</p>
    </div>
  );
};
